import { getCategory } from "@/api/category"
import { transformCateDataToCascaderData, getRequestHeaders } from "@/utils/utils"
// import LruCache from "@/utils/lru-cache"

export default async function ({ store, req, $Logger }) {
  // consy = store.state.lang
  const cascaderData = store.state.cascaderData

  // const _cascaderData = LruCache.get(`${lang}_cascaderData`)
  // if(_cascaderData) {
  //   cascaderData = _cascaderData
  //   store.commit('setCascaderData', cascaderData)
  // }

  if (!cascaderData) {
    try {
      // 获取服务端的Cookie
      const serverCookie = req?.headers?.cookie
      const commonParams = store.state.commonParams
      $Logger.log("初始化分类数据")
      // 调用接口获取分类数据
      const { data } = await getCategory(
        {
          comm: {
            venderId: commonParams.venderId,
            businessCode: 1,
            storeId: commonParams.storeId
          }
        },
        {
          headers: getRequestHeaders({ req, store })
        }
      )

      if (data && data.wareCategory && data.wareCategory.length) {
        // 将分类数据转换为级联数据并存储到Vuex store
        const cascaderData = transformCateDataToCascaderData(data.wareCategory[0].categoryList)
        store.commit("setCascaderData", cascaderData)
        // LruCache.set(`${lang}_cascaderData`, cascaderData)
      }
    } catch (err) {
      $Logger.error("获取分类数据失败:", err)
    }
  }
}
